import React from 'react';
import { Grid, Box } from '@mui/material';
import styles from './support.module.scss';
import { Faq } from 'components/Faq';
import { FAQ_DATA } from 'utils/faqData';

const Support = () => {
  return (
    <Box className={styles.dashboardContainer}>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Faq faqs={FAQ_DATA} />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Support;
